import React, { useEffect, useRef, useState } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { TypeObjectMap, TypeLayer } from '../../../../../../components/Map/providers/enums';
import { NotificationManager } from '../../../../../../components/Notifications';

import { Modal } from '@gpstrackit/gtc-react-controls';
import Map from '../../../../../../components/Map'

import {
    openModalMarkerRoute, 
    setLatLng,
    setMapRestart
  } from 'Redux/actions';

import{
    openModalCreateEditRouteModalMain,
    reset
} from './redux/slice'

import {
    reset as clearCreateEditRoutePoint
} from '../createEditRoutePoint/redux/slice'

import EditPanelRoute from '../editPanelRoute';
import ModalMarkerRoute from '../modalMarkerRoute';
import ModalMarkerRouteDirections from '../modalDirections';
import RoutesDeleteRoutePoints from '../deleteRoutePoint'
import './style.scss'

import { updateErrorOnMap } from './redux/slice'

import { routesEditPanelRouteGetRoute } from '../editPanelRoute/redux/slice'

const CreateEditRouteModalMain = (props) => {

    const { messages, locale } = useIntl();

    const dispatch = useDispatch();

    const mapRef = useRef()

    const [showEditPanel, setShowEditPanel] = useState(true);

    const open = useSelector(state => state.routesManagedCreateEditRouteModalMainRedux?.open);
    const loading = useSelector(state => state.routesManagedCreateEditRouteModalMainRedux?.loading);
    const routeId = useSelector(state => state.routesManagedCreateEditRouteModalMainRedux?.routeId);
    const isKph = useSelector((state) => state.securityRedux.user.isKph);

    const route = useSelector(state => state.routesManagerEditPanelRouteRedux?.route);
    
    const generatePrint = useSelector(state => state.realtimeMapRedux.generatePrint);
    const pointOnMap = useSelector(state => state.realtimeMapRedux.pointOnMap);
    const createTypeSelect = useSelector(state => state.realtimeMapLandmarkModuleRedux.createTypeSelect);
    const openCreateEditRoutePoint = useSelector(state => state.routesManagedCreateEditRoutePointRedux.open); 
    const isUpdatedStopOrder = useSelector(state => state.routesManagerEditPanelRouteRedux.isUpdatedStopOrder);

    const openModalRouteDirections = useSelector(state => state.routesManagedDirectionRedux?.open);
    const isRealtimeMaps = useSelector(state => state.routesManagedDirectionRedux.isRealtimeMaps);

    const paramIsTemplateRoutesModalMain = useSelector(state => state.routesManagedCreateEditRouteModalMainRedux?.isTemplate);
    const paramIsTemplateRealtimeMapsRoutes = useSelector(state => state.realtimeMapsRoutesModalCreateEditRoute?.isTemplate);
    const paramIsTemplate = paramIsTemplateRoutesModalMain || paramIsTemplateRealtimeMapsRoutes || false;

    const handleClose = () => {
        dispatch(clearCreateEditRoutePoint())
        dispatch(reset())
        dispatch(openModalCreateEditRouteModalMain({ open: false, data: null }))
        
    }

    const {
        pointers,
        directions,
        noCenterPoints,
        directionsError
    } = useSelector((state) => state.realtimeMapRedux);

    let newPointers = []

    //create the points on map when route comes to data
    if(route){
        route?.points?.map((item) => {
            newPointers.push({
                ...item, 
                layerName: TypeLayer?.FSMRoute,
                eventName: item?.typePoint
            })
        });
    }

    useEffect(()=> {
        if(mapRef?.current){
            mapRef.current.addMapClickRouteListener()
        }
        
        return () => {
            dispatch(setMapRestart())
        }
    },[])

    useEffect(() => {
        if(open && routeId > 0){
            dispatch(routesEditPanelRouteGetRoute({id: routeId}))
        }
    },[open, routeId])

    useEffect(()=> {
        if(isUpdatedStopOrder && routeId > 0){
            dispatch(routesEditPanelRouteGetRoute({id: routeId}))
        }
    },[isUpdatedStopOrder])

    const onRouteMarkerClick = (event) => {
        dispatch(openModalMarkerRoute({open: true, data: event?.mapObject}))
    }

    const onRouteMapClick = (event) => {
        //al markers to routes display the normal position
        mapRef.current.showNormalMarkers()
        dispatch(openModalMarkerRoute({open: false, data: null}))
    }

     /*********************************************************
     * Return the position from MapClick event in map
    *********************************************************/
     const onMapClick = (latLng) => {
        dispatch(setLatLng(latLng))
    }    

    const errorMapRoutesError = (paramMap) => {
        //show modal route
        NotificationManager.warning(
            messages['fsmRoute_modal_editCreate_error_incorrect_route'],
            messages['realtimemaps_title'],
            9000,
            null,
            null,
            'warning',
            null
        );
        dispatch(updateErrorOnMap({ errorOnMap: true }))
    }
    
    return(
        <div id="divReferenceRoutes">
            <Modal
                title={routeId > 0 ? route?.title : messages['fsmRoute_modal_editCreate_create']}
                open={open}
                disablePortal={true}
                loading={loading}
                position="right"
                size="full-screen"
                handleClose={handleClose}
                closeButton={false}
                className={'route-class-element-map-complete-hidden-scrollbar'}
            >
                <div style={{ overflow: 'hidden' }}>
                    <Map 
                        ref={mapRef} 
                        //units={pointers}
                        //pointers={newPointers}
                        locale={locale}
                        pointers={pointers}
                        noCenterPoints={noCenterPoints}
                        directions={directions} 
                        noRealtime={true} 
                        hiddenButton={true}
                        hiddenTraffic={true}
                        hiddenWeather={true}
                        hiddenLegends={true}
                        hiddenSearchMap={true}
                        height={"95vh"}
                        isKph={isKph}
                        //to create points on map
                        onMapClick={onMapClick}
                        /* Create the marker point into the map */
                        pointOnMap={pointOnMap}
                        /* Type select map to create polygon or circle */
                        createTypeSelect={createTypeSelect}

                        isEditRoutesModule={true}
                        onRouteMarkerClick={onRouteMarkerClick}
                        onRouteMapClick={onRouteMapClick}
                        classNameToMap={!showEditPanel ? 'route-class-element-map-complete': 'route-class-element-map-complete-sidebar'}
                        generatePrint={generatePrint}
                        onEventMapRoutesError={errorMapRoutesError}
                        {...props}>    
                    </Map>
                    
                    <EditPanelRoute 
                        showEditPanel={showEditPanel}
                        hiddenButton={false} 
                        mapRef={mapRef}
                        title={paramIsTemplate ? messages['fsmRoute_title'] : messages['fsmRoute_title_schedule'] }
                        newPointers={newPointers}
                        closeEditPanel={(show)=>{
                            setShowEditPanel(show)
                        }}
                    />
                    <ModalMarkerRoute data={newPointers} mapRef={mapRef} />
                    { openModalRouteDirections && !isRealtimeMaps && <ModalMarkerRouteDirections mapRef={mapRef} /> }
                    <RoutesDeleteRoutePoints />
                </div>
            </Modal>
        </div>
    )

}

export default CreateEditRouteModalMain;

